import React, { useCallback, useState } from 'react';
import { useGetEnrichedScheme } from '../../hooks';
import { FormInner } from '../FormInner';

export const Form: React.FC = () => {
  const formScheme = useGetEnrichedScheme();
  const [formRef, setFormRef] = useState<HTMLFormElement | null>(null);

  const handleSetFormRef = useCallback((node: HTMLFormElement | null) => {
    setFormRef(node);
  }, []);

  return <FormInner formScheme={formScheme} handleSetFormRef={handleSetFormRef} formRef={formRef} />;
};

Form.displayName = 'Form';
